module.exports = __webpack_public_path__ + "static/media/TransactionArrowGrey.4b60fcbc.svg";